import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getTicketTypes } from './api';
import type { TicketTypesPayload, TicketTypesResponse } from './types';

export const TicketTypesTreeControlGate = createGate<TicketTypesPayload>();

const fxGetTicketTypes = createEffect<
  TicketTypesPayload,
  TicketTypesResponse,
  Error
>().use(getTicketTypes);

export const ticketTypesTreeQuery = createQuery({
  name: 'TicketTypesTree',
  effect: fxGetTicketTypes,
});

sample({
  clock: TicketTypesTreeControlGate.open,
  target: ticketTypesTreeQuery.start,
});
